import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useCreateApplePaySession } from "./use-create-apple-pay-session.js";
import { PaymentServiceProvider, PaymentMethod } from "../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const ApplePaySessionErrors = {
  ApplePaySessionUnsupported: "checkout.express.apple.pay.errors.unsupported"
};
const useApplePayWithActions = ({
  isExpressPayment = true
} = {}) => {
  const [error, setError] = React.useState();
  const { createApplePaySession } = useCreateApplePaySession();
  const payCartWithApplePayActions = React.useCallback(
    ({
      createPaymentRequest,
      completePayment,
      validations,
      saveCustomerDetails,
      disableShippingFormUpdate = true
    }) => {
      if (typeof ApplePaySession === "undefined" && error !== "UNSUPPORTED") {
        console.error("Apple pay can only be used on Safari.");
        setError(
          "UNSUPPORTED"
          /* UNSUPPORTED */
        );
        toast.failed(ApplePaySessionErrors.ApplePaySessionUnsupported);
        return null;
      }
      const paymentRequest = createPaymentRequest();
      if (!paymentRequest) {
        return null;
      }
      const session = new ApplePaySession(12, {
        ...paymentRequest,
        ...disableShippingFormUpdate ? {
          shippingContactEditingMode: void 0,
          shippingType: void 0,
          requiredBillingContactFields: void 0,
          requiredShippingContactFields: void 0
        } : {}
      });
      session.onvalidatemerchant = () => {
        createApplePaySession(session);
      };
      session.onshippingcontactselected = (e) => {
        if (validations?.shippingData && !validations.shippingData(e, session, paymentRequest)) {
          return;
        }
        session.completeShippingContactSelection({
          newTotal: paymentRequest.total
        });
        return;
      };
      session.onpaymentauthorized = async (e) => {
        if (isExpressPayment && validations?.paymentData && !validations.paymentData(e, session)) {
          return;
        }
        const applePayToken = btoa(JSON.stringify(e.payment.token.paymentData));
        try {
          saveCustomerDetails && await saveCustomerDetails();
          await completePayment({
            shippingData: e.payment.shippingContact,
            billingData: e.payment.billingContact,
            paymentToken: applePayToken,
            selectedPaymentMethod: {
              type: PaymentMethod.APPLE_PAY,
              provider: PaymentServiceProvider.ADYEN
            }
          });
          session.completePayment(ApplePaySession.STATUS_SUCCESS);
        } catch (e2) {
          session.completePayment(ApplePaySession.STATUS_FAILURE);
        }
      };
      session.oncancel = () => {
        try {
          session.abort();
        } catch (e) {
          if (!(e instanceof Error && e.name === "InvalidAccessError")) {
            throw e;
          }
        }
      };
      session.begin();
      return session;
    },
    [createApplePaySession, error, isExpressPayment]
  );
  return [payCartWithApplePayActions];
};
export {
  ApplePaySessionErrors,
  useApplePayWithActions
};
//# sourceMappingURL=use-apple-pay-with-actions.js.map
